import { useMutation } from "@tanstack/react-query";
import { preiaTargetareLista } from "@/api/endpoints/targetareConfig";

export function usePreiaTargetareLista() {
  return useMutation({
    mutationFn: preiaTargetareLista,
  });
}
